import { FC } from "react";
import * as Meta from 'meta';
export const NoMatchPage: FC = () => {
  return (
    <div>
      {Meta.ga('not-found')}
      {Meta.loadJS(['main-0625'])}
      找不到頁面。耶
    </div>
  );
};
